import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  stagger?: boolean;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  stagger = false
}: AnimatedSectionProps) {
  if (stagger) {
    return <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-50px'
    }} variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
          delayChildren: delay
        }
      }
    }} className={className} data-id="element-44">
        {children}
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-45">
      {children}
    </motion.div>;
}
export function AnimatedItem({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  }} className={className} data-id="element-46">
      {children}
    </motion.div>;
}